import type { WorkflowState } from 'flow/store/redux/state';
import { CANVAS_HORIZONTAL_PADDING, REQUIRED_SPACE_FOR_ISLAND_NODES } from '../constants';
import type { Bounds, SimpleIslandMode } from './types';

export function isPeekingIslandMode(mode: SimpleIslandMode) {
  return mode === 'peeking';
}

/**
 * returns wether the outcome island should be expanded or peeking
 * based on the available space, position and graph elements
 * @todo - this function might be moved somewhere else
 */
export function getSimpleIslandMode(
  graphBounds: Bounds,
  canvasRect: WorkflowState['ui']['canvasProperties']['rect'],
): SimpleIslandMode {
  return (
    canvasRect.x
    + graphBounds.right
    + REQUIRED_SPACE_FOR_ISLAND_NODES
    + CANVAS_HORIZONTAL_PADDING
  ) < canvasRect.width ? 'expanded' : 'peeking';
}
